export default class Admin {
  settings = [];
  settingReplacements = [];
  settingPriorityChanges = [];
  settingRemovals = [];
  permissions = [];
  permissionsReplacements = [];
  permissionsPriorityChanges = [];
  permissionsRemovals = [];
  customPage = null;
  generalIndexes = {};
  constructor(context) {
    if (context === void 0) {
      context = null;
    }
    this.context = context;
  }

  /**
   * Register a setting to be shown on the extension's settings page.
   */
  setting(setting, priority) {
    if (priority === void 0) {
      priority = 0;
    }
    this.settings.push({
      setting,
      priority
    });
    return this;
  }

  /**
   * Replace an existing setting's configuration.
   */
  replaceSetting(setting, replacement) {
    this.settingReplacements.push({
      setting,
      replacement
    });
    return this;
  }

  /**
   * Change the priority of an existing setting.
   */
  setSettingPriority(setting, priority) {
    this.settingPriorityChanges.push({
      setting,
      priority
    });
    return this;
  }

  /**
   * Remove a setting from the extension's settings page.
   */
  removeSetting(setting) {
    this.settingRemovals.push(setting);
    return this;
  }

  /**
   * Register a custom setting to be shown on the extension's settings page.
   */
  customSetting(setting, priority) {
    if (priority === void 0) {
      priority = 0;
    }
    this.settings.push({
      customSetting: setting,
      priority
    });
    return this;
  }

  /**
   * Register a permission to be shown on the extension's permissions page.
   */
  permission(permission, type, priority) {
    if (priority === void 0) {
      priority = 0;
    }
    this.permissions.push({
      permission,
      type,
      priority
    });
    return this;
  }

  /**
   * Replace an existing permission's configuration.
   */
  replacePermission(permission, replacement, type) {
    this.permissionsReplacements.push({
      permission,
      type,
      replacement
    });
    return this;
  }

  /**
   * Change the priority of an existing permission.
   */
  setPermissionPriority(permission, type, priority) {
    this.permissionsPriorityChanges.push({
      permission,
      type,
      priority
    });
    return this;
  }

  /**
   * Remove a permission from the extension's permissions page.
   */
  removePermission(permission, type) {
    this.permissionsRemovals.push({
      permission,
      type
    });
    return this;
  }

  /**
   * Register a custom page to be shown in the admin interface.
   */
  page(page) {
    this.customPage = page;
    return this;
  }

  /**
   * Register a custom general search index entry.
   */
  generalIndexItems(type, items) {
    this.generalIndexes[type] = items;
    return this;
  }
  extend(app, extension) {
    app.beforeMount(() => {
      app.registry.for(this.context || extension.name);
      this.settings.forEach(_ref => {
        let {
          setting,
          customSetting,
          priority
        } = _ref;
        const settingConfig = setting ? setting() : customSetting;
        if (settingConfig) {
          app.registry.registerSetting(settingConfig, priority);
        }
      });
      this.settingReplacements.forEach(_ref2 => {
        let {
          setting,
          replacement
        } = _ref2;
        app.registry.setSetting(setting, replacement);
      });
      this.settingPriorityChanges.forEach(_ref3 => {
        let {
          setting,
          priority
        } = _ref3;
        app.registry.setSettingPriority(setting, priority);
      });
      this.settingRemovals.forEach(setting => {
        app.registry.removeSetting(setting);
      });
      this.permissions.forEach(_ref4 => {
        let {
          permission,
          type,
          priority
        } = _ref4;
        const permissionConfig = permission();
        if (permissionConfig) {
          app.registry.registerPermission(permissionConfig, type, priority);
        }
      });
      this.permissionsReplacements.forEach(_ref5 => {
        let {
          permission,
          type,
          replacement
        } = _ref5;
        app.registry.setPermission(permission, replacement, type);
      });
      this.permissionsPriorityChanges.forEach(_ref6 => {
        let {
          permission,
          type,
          priority
        } = _ref6;
        app.registry.setPermissionPriority(permission, type, priority);
      });
      this.permissionsRemovals.forEach(_ref7 => {
        let {
          permission,
          type
        } = _ref7;
        app.registry.removePermission(permission, type);
      });
      if (this.customPage) {
        app.registry.registerPage(this.customPage);
      }
      app.generalIndex.for(extension.name);
      Object.keys(this.generalIndexes).forEach(key => {
        if (key !== 'settings' && key !== 'permissions') return;
        const callback = this.generalIndexes[key];
        if (callback) {
          app.generalIndex.add(key, callback());
        }
      });
    });
  }
}
flarum.reg.add('core', 'common/extenders/Admin', Admin);